export default "__VITE_ASSET__26f44870__"